"use strict";
exports.__esModule = true;
exports["default"] = (function (ctx, options) {
    ctx.textAlign = "left";
    ctx.fillText(options.content, 20, 20);
});
